import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CLIENT_PANEL_AUTHENTICATION, CLIENT_PANEL_AUTHENTICATION_SUCCESS, CLIENT_PANEL_AUTHENTICATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getClientPanelAuthentication({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/client/customer-360/authentications`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: CLIENT_PANEL_AUTHENTICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLIENT_PANEL_AUTHENTICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_PANEL_AUTHENTICATION_ERROR, payload: error });
  }
}

export function* watchClientPanelAuthentication() {
  yield takeEvery(CLIENT_PANEL_AUTHENTICATION, getClientPanelAuthentication);
}

function* watchClientPanelAuthenticationSaga() {
  yield all([fork(watchClientPanelAuthentication)]);
}

export default watchClientPanelAuthenticationSaga;
